// extracted by mini-css-extract-plugin
module.exports = {"label":"Address_label__3kmZ1","items":"Address_items__22BNp","input":"Address_input__1VKVS"};